import Constants from '@hoverinc/machete-constants';

import type { TextureAppearance } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';

export enum ProductCategory {
  WALLS = 'WALLS',
  TRIM = 'TRIM',
  ROOF = 'ROOF',
}

/**
 * Note: This is not the same as the label system found in machete & manowar.
 * These labels are product catalog specific, and although they overlap there are many more product catalog labels than there
 * are material labels.
 */
export enum ProductTypeLabel {
  HORIZONTAL_SIDING = Constants.HORIZONTAL_SIDING_ID,
  VERTICAL_SIDING = Constants.VERTICAL_SIDING_ID,
  SHINGLED_SIDING = Constants.SHINGLED_SIDING_ID,
  BRICK_SIDING = Constants.BRICK_LABEL_ID,
  STONE_SIDING = Constants.STONE_LABEL_ID,
  CONCRETE_SIDING = Constants.CONCRETE_LABEL_ID,
  STUCCO_SIDING = Constants.STUCCO_LABEL_ID,

  SHINGLE_ROOF = 920,
  TILE_ROOF = 921,
  METAL_ROOF = 922,

  TRIM = Constants.TRIM_LABEL_ID,
}

export type Provider = {
  uuid: string;
  name: string;
};

export type Product = {
  uuid: string;
  id: number;
  name: string;

  type: ProductTypeLabel;

  provider: Provider;
  variations: Variation[];
};

export enum VariationColorGroup {
  WHITE = 'WHITE',
  BEIGE = 'BEIGE',
  GRAY = 'GRAY',
  BLACK = 'BLACK',
  GREEN = 'GREEN',
  BLUE = 'BLUE',
  YELLOW = 'YELLOW',
  RED = 'RED',
  PURPLE = 'PURPLE',
  BROWN = 'BROWN',
}

export type VariationColor = {
  group: VariationColorGroup;
  hex: string;
  name: string;
};

export type Variation = {
  uuid: string;
  id: number;
  name: string;

  product: Product;

  color?: VariationColor;

  textureId: number;
  thumbnailURL?: string;
  manufacturerURL?: string;

  facets: {
    sizing?: string;
    style?: string;
    texture?: string;
  };
};

/**
 * This data structure is created when the user selects filters through the UI.
 *
 * For example if the user wanted to view green horizontal hiding the following
 * filter object would encode that.
 *
 * const filter: ProductFilter = {
 *     productType: ProductTypeLabel.HORIZONTAL_SIDING,
 *     colors: [GREEN]
 * }
 *
 */
export type ProductFilter = {
  productType: ProductTypeLabel;
  providers: string[];
  colorGroups: VariationColorGroup[];
  styles: string[];
  textures: string[];
  sizes: string[];
};

export type ProductFilterOptions = {
  productTypes: ProductTypeLabel[];
  providers: string[];
  colorGroups: VariationColorGroup[];
  styles: string[];
  textures: string[];
  sizes: string[];
};

export type MaterialGroup = {
  appearance: TextureAppearance;
  variation?: Variation;
};

export const AllProductTypeLabels = [
  ProductTypeLabel.HORIZONTAL_SIDING,
  ProductTypeLabel.VERTICAL_SIDING,
  ProductTypeLabel.SHINGLED_SIDING,
  ProductTypeLabel.BRICK_SIDING,
  ProductTypeLabel.STONE_SIDING,
  ProductTypeLabel.CONCRETE_SIDING,
  ProductTypeLabel.STUCCO_SIDING,
  ProductTypeLabel.SHINGLE_ROOF,
  ProductTypeLabel.TILE_ROOF,
  ProductTypeLabel.METAL_ROOF,
  ProductTypeLabel.TRIM,
];
